import type { GameModel, ReadOnlyGameModel } from 'yage/game/GameModel';
import { DIARY_LINES } from '../domain/save.js';
import { career } from './world.js';

/** TX-030 Family Diary: lines from real events (actual numbers), newest last, kept with the career. */
export function readDiary(json: string): string[] {
    try { const lines = JSON.parse(json); return Array.isArray(lines) ? lines.filter((l): l is string => typeof l === 'string' && l.length > 0).slice(-DIARY_LINES) : []; }
    catch { return []; }
}
export function diaryLines(g: GameModel | ReadOnlyGameModel): string[] { return readDiary(career(g).diary); }
export function addDiary(g: GameModel, text: string) {
    const lines = [...diaryLines(g), text.slice(0, 200)].slice(-DIARY_LINES);
    career(g).diary = JSON.stringify(lines);
}
